//Sass
import './sass/main.scss';

//JS
import './js/all-scripts';

import 'bootstrap';